<template>
    <vx-input v-bind="attrs" v-on="listeners" v-mask="abn_mask" v-model="abn" />
</template>

<script>
export default {
    name: 'vx-abn-input',
    props: {
        value: {
            type: String
        },
        label: {
            type: String,
            default: 'ABN'
        },
        rules: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            abn_mask: '## ### ### ###'
        }
    },
    computed: {
        abn: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        rules_x() {
            return [...this.rules, 'abn']
        },
        listeners() {
            var result = { ...this.$listeners }
            delete result.input
            return result
        },
        attrs() {
            return {
                name: 'abn',
                icon: 'icon-briefcase',
                placeholder: this.abn_mask,
                label: this.label,
                ...this.$attrs,
                rules: this.rules_x
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
